module.exports = __webpack_public_path__ + "img/icon04.aa79bccd.png";